import { render, staticRenderFns } from "./ManageMemberGroupDetail.vue?vue&type=template&id=66e3bd3c"
import script from "./ManageMemberGroupDetail.vue?vue&type=script&lang=js"
export * from "./ManageMemberGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./ManageMemberGroupDetail.vue?vue&type=style&index=0&id=66e3bd3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports